import { MedicationStrength } from "~/common/types";

export const getSelectedStrengthAmount = (
  strengthId: string,
  strengths?: MedicationStrength[],
) => strengths?.find(({ id }) => id === strengthId)?.amount ?? 0;
